module.exports = __webpack_public_path__ + "static/media/fabrica.b57a99f5.png";